import { zodResolver } from '@hookform/resolvers/zod';
import React, { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import styled from 'styled-components';
import { z } from 'zod';

import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import HeadingText from '@ui/atoms/HeadingText';
import SelectableButton from '@ui/atoms/SelectableButton';
import SelectableButtonGroup from '@ui/atoms/SelectableButtonGroup';

import BackAndNextNav, { IBackAndNextNavProps } from '@ui/molecules/BackAndNextNav';
import CenteredGridItem from '@ui/molecules/CenteredGridItem';

import fullWidth from '@ui/styled/FullWidth';

import { commonLabels } from '@utils/button';

import { IFlowStepComponentProps } from '@folx-types/flow-steps';

import theme from '@theme/FolxTheme';

import { schema } from './MemberAdhdDiagnosisStep.data';

export interface IMemberAdhdDiagnosisStepPageContent {
	pageHeader: string;
}

interface IMemberAdhdDiagnosisStepProps extends IFlowStepComponentProps {
	pageContent: IMemberAdhdDiagnosisStepPageContent;
}

const FullWidthColumn = fullWidth<IFlexColumn>(FlexColumn);
const FullWidthNavigation = fullWidth<IBackAndNextNavProps>(BackAndNextNav);

const BinarySelectableButton = styled(SelectableButton)`
	width: 100%;
	@media ${theme.responsive.breakpoints.tablet} {
		width: ${theme.spacing.xxxxxl};
	}
`;

const MemberAdhdDiagnosisStep: FC<IMemberAdhdDiagnosisStepProps> = ({
	pageContent,
	existingFormData,
	handleFormSubmission = () => {},
	handleNavBack = () => {},
	stepKey,
}) => {
	const { pageHeader } = pageContent;

	type Schema = Partial<z.input<typeof schema>>;

	const form = useForm<Schema>({
		defaultValues: {
			...(existingFormData as unknown as Schema),
		},
		resolver: zodResolver(schema),
		mode: 'onChange',
	});
	const {
		handleSubmit,
		control,
		formState: { errors },
	} = form;

	const onSubmit = (data: Record<string, unknown>) => {
		handleFormSubmission(data, stepKey);
	};

	return (
		<CenteredGridItem>
			<FullWidthColumn gap="sm">
				<HeadingText>{pageHeader}</HeadingText>
				<form onSubmit={handleSubmit(onSubmit)}>
					<FullWidthColumn gap="lgxl">
						<Controller
							name="adhdDiagnosis"
							control={control}
							render={({ field: { value, ...field } }) => (
								<SelectableButtonGroup layout="multi" name="adhdDiagnosis">
									<BinarySelectableButton {...field} optionValue="yes" value={value ?? ''}>
										{commonLabels.yes}
									</BinarySelectableButton>
									<BinarySelectableButton {...field} optionValue="no" value={value ?? ''}>
										{commonLabels.no}
									</BinarySelectableButton>
								</SelectableButtonGroup>
							)}
						/>
						<FullWidthNavigation
							backOnClick={() => handleNavBack(stepKey)}
							submitLabel={commonLabels.next}
						/>
					</FullWidthColumn>
				</form>
			</FullWidthColumn>
		</CenteredGridItem>
	);
};

export default MemberAdhdDiagnosisStep;
